import { ActorType } from "@common/types/auditLog";
import { useIsFirmMemberOrStandaloneUser } from "@hooks/useIsFirmMemberOrStandaloneUser";

export function useIsVisibleAgentActor(actorType: string): boolean {
    const canSeeAgentIdentity = useIsFirmMemberOrStandaloneUser();
    return canSeeAgentIdentity && actorType === ActorType.AGENT;
}
